// extracted by mini-css-extract-plugin
export var bounds = "TickList-module--bounds--ca5ca";
export var circle = "TickList-module--circle--f952d";
export var content = "TickList-module--content--1c98f";
export var icon = "TickList-module--icon--7d3cc";
export var item = "TickList-module--item--634f0";
export var list = "TickList-module--list--350dc";
export var reverse = "TickList-module--reverse--e98b1";